import { createFileRoute } from '@tanstack/react-router';
import { PilotPage } from '@/components/OttoPilot/PilotPage';

export const Route = createFileRoute('/_authenticated/pilot/')({
  component: PilotPage,
  validateSearch: (
    search: Record<string, unknown>
  ): { prompt?: string; promptTemplateId?: string } => ({
    prompt: typeof search.prompt === 'string' ? search.prompt : undefined,
    promptTemplateId:
      typeof search.promptTemplateId === 'string' ? search.promptTemplateId : undefined,
  }),
});
